export default __webpack_public_path__ + "static/media/242.a26d913b.jpg";